export function loadForElements(els, importer) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';

  if (els.length > 0) {
    importer().then(function (module) {
      return module[method] && module[method](els);
    });
  }
}